import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResearchUnitsService } from '../research-units.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SEOService } from '../../core/seo.service';
import { EsploroEntity } from '../../shared/interfaces/esploro-entity';
import { AcademicUnitPortalDTO } from 'src/app/shared/external-model/academicunit/academic-unit-portal-dto';
import { TranslateObjectPipe } from '../../shared/pipes/translate-object.pipe';
import { ResearchUnitMetricsComponent } from '../research-unit-metrics/research-unit-metrics.component';
import { ResearchUnitCollectionsComponent } from '../research-unit-collections/research-unit-collections.component';
import { CenteredBlockLayoutComponent } from '@exl-ng/mulo-views';
import { MatTabNavPanel } from '@angular/material/tabs';
import { ResearchUnitNavComponent } from '../research-unit-nav/research-unit-nav.component';
import { ResearchUnitHeaderComponent } from '../research-unit-header/research-unit-header.component';
import {
    PrologueComponent,
    ExpandableComponent,
    SeparatorComponent,
    HtmlTrustPipe,
} from '@exl-ng/mulo-common';
import { ResearchUnitMediaMentionsComponent } from '../research-unit-media-mentions/research-unit-media-mentions.component';

@Component({
    selector: 'esp-research-unit-homepage',
    templateUrl: './research-unit-homepage.component.html',
    styleUrls: ['./research-unit-homepage.component.scss'],
    imports: [
        PrologueComponent,
        ResearchUnitHeaderComponent,
        ResearchUnitNavComponent,
        MatTabNavPanel,
        CenteredBlockLayoutComponent,
        ExpandableComponent,
        SeparatorComponent,
        ResearchUnitCollectionsComponent,
        ResearchUnitMetricsComponent,
        TranslateModule,
        TranslateObjectPipe,
        HtmlTrustPipe,
        ResearchUnitMediaMentionsComponent,
    ],
})
export class ResearchUnitHomepageComponent {
    private route = inject(ActivatedRoute);
    private unitsSvc = inject(ResearchUnitsService);
    private translate = inject(TranslateService);
    private seoService = inject(SEOService);

    unitCode: string;
    unit: AcademicUnitPortalDTO;
    images: any[];
    descriptions: any[];
    links: any[];
    sections: EsploroEntity[];

    constructor() {
        const route = this.route;
        const unitsSvc = this.unitsSvc;

        route.params.subscribe((params) => {
            const unitCode = params['unitCode'];
            this.unitCode = unitCode;
            unitsSvc.homepageOrgUnitCode.set(unitCode);
            unitsSvc.getResearchUnitByCode(unitCode).subscribe((res) => {
                this.unit = res;
                this.getUnitData();
                this.updateTitle();
            });
        });
        this.sections = unitsSvc.configHomepageSections;
    }

    getUnitData() {
        this.unitsSvc.getResearchUnitFiles(this.unit.id).subscribe((res) => {
            this.images = res.filter(
                (_) => _.contentType === 'academicUnit.gallery',
            );
        });
        this.unitsSvc
            .getResearchUnitDescriptions(this.unit.id)
            .subscribe((res) => {
                this.descriptions = res.filter(
                    (_) => _.type === 'academicUnit.general',
                );
            });
        this.unitsSvc.getResearchUnitLinks(this.unit.id).subscribe((res) => {
            this.links = res.filter(
                (_) => _.contentType === 'academicUnit.homepage',
            );
        });
    }

    updateTitle() {
        const titleCode = ['research.search.academic.units', this.unitCode];
        this.translate.get(titleCode).subscribe((title) => {
            const translatedTitle =
                typeof title === 'string'
                    ? title
                    : Object.values(title).join(' - ');
            this.seoService.updatePageTitle(translatedTitle);
        });
    }
}
